import React from "react";
import { ICookieConsentDialogStrings } from "../Components/CookieConsent/CookieConsentDialog";

export const defaultCookieConsentStringsValue: ICookieConsentDialogStrings = {
  cookieConsentDialog_ButtonAcceptAll: "",
  cookieConsentDialog_ButtonChange: "",
  cookieConsentDialog_ButtonChangeSmall: "",
  cookieConsentDialog_ButtonStoreChanges: "",
  cookieConsentDialog_Header: "",
  cookieConsentDialog_HeaderChange: "",
  cookieConsentDialog_HeaderNecessary: "",
  cookieConsentDialog_HeaderAnalysis: "",
  cookieConsentDialog_HeaderMarketing: "",
  cookieConsentDialog_HeaderPersonalization: "",
  cookieConsentDialog_Info: "",
  cookieConsentDialog_InfoAnalysis: "",
  cookieConsentDialog_InfoMarketing: "",
  cookieConsentDialog_InfoNecessary: "",
  cookieConsentDialog_InfoPersonalization: "",
  cookieConsentDialog_ReadMore: "",
  cookieConsentDialog_ReadMoreLink: "",
  cookieConsentDialog_PrivacyPolicyLink: "",
  cookieConsentDialog_SwitchAlwaysOn: "",
};

export const CookieConsentStringContext = React.createContext<ICookieConsentDialogStrings>(
  defaultCookieConsentStringsValue,
);
